











import arrow from 'library/assets/images/animated-arrow.gif'

export default

	props:
		label: String

	data: -> { arrow }

